import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Tax } from 'projects/Administration/src/app/business-entities/tax.model';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { TaxDetailsService } from './../../../../business-services/tax-details.service';


@Component({
    selector: 'app-edit-tax-details',
    templateUrl: 'edit-tax-details.component.html',
    styleUrls: ['edit-tax-details.component.css']
})
export class EditTaxDetailsComponent implements OnInit {

    @Input() dealerId: string;
    taxDetails: FormGroup;
    taxPercentages: Tax[] = [];
    personnelTax: Tax;
    materialTax: Tax;
    personnelTaxPercentage: number = 0;
    materialTaxPercentage: number = 0;
    isDealerLoggedIn: boolean;
    isMaterialTaxRequired = true;

    constructor(
        private taxDetailsService: TaxDetailsService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private activeModal : NgbActiveModal,
        private userService: UserDataService
    ) { }

    ngOnInit(): void {
        this.isMaterialTaxRequired = localStorage.getItem("Theme") !== 'mg';
        this.isDealerLoggedIn = this.userService.currentUserValue.roleType === fromEnums.UserRoles.DealerAdmin;
        this.initilize();
    }

    get cpf() {
        return this.taxDetails.controls;
    }

    isDigit(event): void {
        const isDigit = Utility.isDigit(event);
        if (!isDigit) {
            event.preventDefault();
        }
    }

    async initilize(): Promise<void> {
        await this.getTaxDetails();
        this.initializeForm();
    }

    async getTaxDetails(): Promise<void> {
        this.taxPercentages = await this.taxDetailsService.getTaxPercentages(this.dealerId);
        this.personnelTax = this.taxPercentages.find(x => x.taxTypeId === fromEnums.TaxType.Personnel);
        this.materialTax = this.taxPercentages.find(x => x.taxTypeId === fromEnums.TaxType.Material);
        this.personnelTaxPercentage = this.personnelTax ? this.personnelTax.percentage : 0;
        this.materialTaxPercentage = this.materialTax ? this.materialTax.percentage : 0;
    }

    initializeForm(): void {
        this.taxDetails = new FormGroup({
            personnel: new FormControl(this.personnelTaxPercentage, [Validators.required, Validators.pattern(/^((100)|\d{0,2}(\.\d{1,2})?)$/)]),
            material: new FormControl(this.materialTaxPercentage, [Validators.required, Validators.pattern(/^((100)|\d{0,2}(\.\d{1,2})?)$/)])
        });
    }

    onSaveChanges(): void {
        const viewModel = this.createViewModel();
        this.spinner.show();
        this.taxDetailsService.updatetaxPercentages(viewModel)
            .then((response) => {
                let result = response.responseObject;
                if (result) {
                    this.toastr.success(fromEnums.ToastrMessages.DealerTaxDetailsUpdated);
                } else {
                    this.toastr.error(fromEnums.ToastrMessages.DealerTaxDetailsUpdateFailed);
                }
                this.spinner.hide();
            });
    }

    createViewModel(): Tax[] {
        if (!this.personnelTax) {
            this.personnelTax = this.initializeTax(fromEnums.TaxType.Personnel);
        }
        this.personnelTax.percentage = +this.cpf.personnel.value;
        if (!this.materialTax) {
            this.materialTax = this.initializeTax(fromEnums.TaxType.Material);
        }
        this.materialTax.percentage = +this.cpf.material.value;
        const viewModel: Tax[] = [
            this.personnelTax,
            this.materialTax
        ];
        return viewModel;
    }

    initializeTax(taxTypeId: number): Tax {
        return {
            id: 0,
            dealerId: this.dealerId,
            taxTypeId: taxTypeId,
            percentage: 0
        } as Tax;
    }


  OnClose(){
    this.activeModal.close({ success: true });
  }

}
